import { render, staticRenderFns } from "./webmenu.vue?vue&type=template&id=4cb52860&"
import script from "./webmenu.vue?vue&type=script&lang=js&"
export * from "./webmenu.vue?vue&type=script&lang=js&"
import style0 from "./webmenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports